module.exports = __webpack_public_path__ + "static/media/垃圾分类装置侧面.33f9bc6b.png";